import * as types from "../actions/actionTypes";

const initialState = {
    isFetched: false,
    error: null,
    allStations: [],
    JSONStringList: [],
    selectedStation: "",
    flightFilters: {}
};

export default function StationReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_STATIONNAME_REQUEST:
            return {
                ...state,
                isFetched: true,
            };

        case types.GET_STATIONNAME_SUCCESS:
            return {
                ...state,
                isFetched: false,
                allStations: action.allStations,
                JSONStringList: action.JSONStringList,
            };

        case types.GET_STATIONNAME_FAIL:
            return {
                ...state,
                isFetched: false,
                error: action.payload,
            };

        case types.SET_SELECTEDSTATION:
            return {
                ...state,
                selectedStation: action.selectedStation,
            };

        default:
            return state;
    }
}

//export default flightDetailsReducer
